import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=39aa5556&scoped=true"
import script from "./Markets.vue?vue&type=script&lang=ts"
export * from "./Markets.vue?vue&type=script&lang=ts"
import style0 from "./Markets.vue?vue&type=style&index=0&id=39aa5556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa5556",
  null
  
)

export default component.exports